import client from '../client';
import { ValueLists } from '../enums/ValueListsEnums';
import {
  CompaniesDocument,
  CompaniesNamesDocument,
  ICompaniesQuery,
  ICompaniesNamesQuery,
  ICompany,
  IContact,
  ContactsDocument,
  IContactsQuery,
  IProduct,
  IProductsQuery,
  ProductsDocument,
  MembershipsDocument,
  IMembershipsQuery,
  IMembership,
  IGetUsersQuery,
  GetUsersDocument,
  IInvoice,
  IInvoicesQuery,
  InvoicesDocument,
  IUser,
  GetRolesDocument,
  IGetRolesQuery,
  IRole,
  IAddValueResult,
  CompanyTypesDocument,
  ICompanyTypesQuery,
  ICompanyType,
  MarketActivitiesDocument,
  IMarketActivitiesQuery,
  IMarketActivity,
  MembershipTypesDocument,
  IMembershipTypesQuery,
  IMembershipType,
  ProductCodesDocument,
  IProductCodesQuery,
  IProductCode,
  TitlesInternalDocument,
  ITitlesInternalQuery,
  ITitleInternal,
  IAddInterestResult,
  IInterest,
  GetInterestGroupsDocument,
  IGetInterestGroupsQuery,
  ITemplate,
  TemplatesDocument,
  ITemplatesQuery,
  RecipientListsDocument,
  IRecipientListsQuery,
  IRecipientList,
  IGetAllScheduledQuery,
  GetAllScheduledDocument,
  IScheduler,
  IEventsQuery,
  EventsDocument,
  ICalendarEvent,
  IStock,
  StocksDocument,
  IStocksQuery,
  IIndex,
  IndicesDocument,
  IIndicesQuery,
  IIndexSerie,
  IndexSeriesDocument,
  IIndexSeriesQuery,
  IEtf,
  GetEtfsDocument,
  IGetEtfsQuery,
  GetFtseFilesDocument,
  IGetFtseFilesQuery,
  IFtseFile,
  IFtseConfiguration,
  GetFtseConfigurationsDocument,
  IGetFtseConfigurationsQuery,
  GetSiteSectionsDocument,
  IGetSiteSectionsQuery,
  ISiteSection,
  IDocument,
  DocumentsDocument,
  IDocumentsQuery
} from '../generated/graphql';

export const similarCompanyNameExists = (name: string, id?: number): boolean => {
  try {
    const companiesQuery = client.cache.readQuery({
      query: CompaniesDocument
    }) as ICompaniesQuery;
    if (companiesQuery.result) {
      const companies = companiesQuery.result.filter((c) =>
        c?.name.toLowerCase().includes(name.toLowerCase())
      );
      if (companies.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedComapnies = companies.filter((c) => parseInt(c?.id as string) !== id);
          return refinedComapnies.length > 0;
        }
        return true;
      }
    }
  } catch (e) {
    return false;
  }

  return false;
};

export const sameCompanyNameExists = (name: string, id?: number): boolean => {
  try {
    const companiesQuery = client.cache.readQuery({
      query: CompaniesDocument
    }) as ICompaniesQuery;
    if (companiesQuery.result) {
      const companies = companiesQuery.result.filter(
        (c) => c?.name.toLowerCase() === name.toLowerCase()
      );
      if (companies.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedComapnies = companies.filter((c) => parseInt(c?.id as string) !== id);
          return refinedComapnies.length > 0;
        }
        return true;
      }
    }
  } catch (e) {
    return false;
  }

  return false;
};

export const sameRecipientListExists = (name: string, id?: number): boolean => {
  try {
    const recipientListQuery = client.cache.readQuery({
      query: RecipientListsDocument
    }) as IRecipientListsQuery;
    if (recipientListQuery.result) {
      const listName = recipientListQuery.result.filter(
        (rl) => rl?.name?.toLocaleLowerCase() === name.toLowerCase()
      );
      if (listName.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedList = listName.filter((rl) => parseInt(rl?.id as string) !== id);
          return refinedList.length > 0;
        }
        return true;
      }
    }
  } catch (e) {
    return false;
  }

  return false;
};

export const sameContactEmailExists = (email: string): boolean => {
  let result = false;
  try {
    const contactsQuery = client.cache.readQuery({
      query: ContactsDocument
    }) as IContactsQuery;

    // Check if contactsQuery and contactsQuery.result exist before proceeding
    if (contactsQuery && contactsQuery.result) {
      const contact = contactsQuery.result.find(
        (c) => c?.email?.toLowerCase() === email.toLowerCase()
      );
      result = contact ? true : false;
      return result;
    }
  } catch (e) {
    return result;
  }

  return result;
};

export const fullNameExists = (
  firstName: string,
  lastName: string,
  companyName: string
): boolean => {
  let result = false;
  if (!firstName || !lastName || !companyName) {
    return result;
  }
  try {
    const contactsQuery = client.cache.readQuery({
      query: ContactsDocument
    }) as IContactsQuery;

    // Check if contactsQuery and contactsQuery.result exist before proceeding
    if (contactsQuery && contactsQuery.result) {
      const contact = contactsQuery.result.find(
        (c) =>
          c?.company.name === companyName &&
          c.fullName.toLowerCase() === `${firstName.toLowerCase()} ${lastName.toLowerCase()}`
      );
      result = contact ? true : false;
      return result;
    }
  } catch (e) {
    return result;
  }

  return result;
};

export const sameUsernameExists = (name: string, id?: string): boolean => {
  try {
    const usersQuery = client.cache.readQuery({
      query: GetUsersDocument
    }) as IGetUsersQuery;
    if (usersQuery.result) {
      const users = usersQuery.result.filter(
        (u) => u?.username.toLowerCase() === name.toLowerCase()
      );
      if (users.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedUsers = users.filter((u) => parseInt(u?.id as string) !== parseInt(id));
          return refinedUsers.length > 0;
        }
        return true;
      }
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const sameTemplateTitleExists = (title: string, id?: string): boolean => {
  try {
    const templatesQuery = client.cache.readQuery({
      query: TemplatesDocument
    }) as ITemplatesQuery;
    if (templatesQuery.result) {
      const templates = templatesQuery.result.filter(
        (t) => t?.title.toLowerCase() === title.trim().toLowerCase()
      );
      if (templates.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedTempaltes = templates.filter(
            (t) => parseInt(t?.id as string) !== parseInt(id)
          );
          return refinedTempaltes.length > 0;
        }
        return true;
      }
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const sameProductNameExists = (name: string, id?: string): boolean => {
  try {
    const productsQuery = client.cache.readQuery({
      query: ProductsDocument
    }) as IProductsQuery;
    if (productsQuery.result) {
      const products = productsQuery.result.filter(
        (p) => p?.name.toLowerCase() === name.toLowerCase()
      );
      if (products.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedProducts = products.filter((p) => p?.id === id);
          return refinedProducts.length > 0;
        }
      }

      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const sameIndexCodeExists = (code: string, id?: string): boolean => {
  try {
    const indicesQuery = client.cache.readQuery({
      query: IndicesDocument
    }) as IIndicesQuery;
    if (indicesQuery.result) {
      const indices = indicesQuery.result.filter(
        (i) => i?.code.toUpperCase() === code.toUpperCase().trim()
      );
      if (indices.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedIndex = indices.filter((i) => i?.id !== id);
          return refinedIndex.length > 0;
        }
      }
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const sameFtseFileNameExists = (name: string, id?: string): boolean => {
  try {
    const ftseFilesQuery = client.cache.readQuery({
      query: GetFtseFilesDocument
    }) as IGetFtseFilesQuery;
    if (ftseFilesQuery.result) {
      const ftseFiles = ftseFilesQuery.result.filter(
        (ftse) => ftse?.name.toUpperCase() === name.toUpperCase().trim()
      );
      if (ftseFiles.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedFtseFile = ftseFiles.filter((ftse) => ftse?.id !== id);
          return refinedFtseFile.length > 0;
        }
      }
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const indexSerieWithThatNameExists = (indexSerie: string, id?: string): boolean => {
  try {
    const indexSerieQuery = client.cache.readQuery({
      query: IndexSeriesDocument
    }) as IIndexSeriesQuery;
    if (indexSerieQuery.result) {
      const indexSeries = indexSerieQuery.result.filter(
        (is) => is?.name.toUpperCase() === indexSerie.toUpperCase().trim()
      );
      if (indexSeries.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedIndexSerie = indexSeries.filter((is) => is?.id !== id);
          return refinedIndexSerie.length > 0;
        }
      }
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const addCompanyToCache = (company: ICompany): void => {
  try {
    const companiesQuery = client.cache.readQuery({
      query: CompaniesDocument
    }) as ICompaniesQuery;
    if (companiesQuery.result) {
      const cacheCompany = companiesQuery.result.find((c) => c?.id === company.id);
      if (!cacheCompany) {
        const data = [company, ...companiesQuery.result];
        client.writeQuery({
          query: CompaniesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateCompanyInCache = (company: ICompany): void => {
  try {
    const companiesQuery = client.cache.readQuery({
      query: CompaniesDocument
    }) as ICompaniesQuery;
    if (companiesQuery?.result) {
      const data = companiesQuery.result.map((c) => (c?.id === company.id ? company : c));
      client.writeQuery({
        query: CompaniesDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeCompanyFromCache = (company: ICompany): void => {
  try {
    // Remove from CompaniesDocument cache
    const companiesQuery = client.cache.readQuery({
      query: CompaniesDocument
    }) as ICompaniesQuery;
    if (companiesQuery.result) {
      const cacheCompany = companiesQuery.result.find((c) => c?.id === company.id);
      if (cacheCompany) {
        const data = companiesQuery.result.filter(function (el) {
          return el?.id !== company.id;
        });
        client.writeQuery({
          query: CompaniesDocument,
          data: { result: data }
        });
      }
    }

    // Also remove from CompaniesNamesDocument cache (used for name filter)
    try {
      const companiesNamesQuery = client.cache.readQuery({
        query: CompaniesNamesDocument
      }) as ICompaniesNamesQuery;
      if (companiesNamesQuery.result) {
        const cacheCompany = companiesNamesQuery.result.find((c) => c?.id === company.id);
        if (cacheCompany) {
          const data = companiesNamesQuery.result.filter(function (el) {
            return el?.id !== company.id;
          });
          client.writeQuery({
            query: CompaniesNamesDocument,
            data: { result: data }
          });
        }
      }
    } catch (namesError) {
      // If CompaniesNamesDocument doesn't exist or query fails, ignore
    }
  } catch (e) {}
};

export const createUserToCache = (user: IUser): void => {
  try {
    const usersQuery = client.cache.readQuery({
      query: GetUsersDocument
    }) as IGetUsersQuery;
    if (usersQuery.result) {
      const cacheUser = usersQuery.result.find((u) => u?.id === user.id);
      if (!cacheUser) {
        const data = [user, ...usersQuery.result];
        client.writeQuery({
          query: GetUsersDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
  } finally {
    updateUserGroupsInCache(user);
  }
};

export const removeUserFromCache = (user: IUser): void => {
  try {
    const usersQuery = client.cache.readQuery({
      query: GetUsersDocument
    }) as IGetUsersQuery;
    if (usersQuery.result) {
      const cacheUser = usersQuery.result.find((u) => u?.id === user.id);
      if (cacheUser) {
        const data = usersQuery.result.filter(function (el) {
          return el?.id !== user.id;
        });
        client.writeQuery({
          query: GetUsersDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
  } finally {
    removeUserFromAllGroupsInCache(user.id);
  }
};

export const removeContactFromCache = (contact: IContact): void => {
  try {
    const contactsQuery = client.cache.readQuery({
      query: ContactsDocument
    }) as IContactsQuery;

    // Check if contactsQuery and contactsQuery.result exist before proceeding
    if (contactsQuery && contactsQuery.result) {
      const cacheContact = contactsQuery.result.find((c) => c?.id === contact.id);
      if (cacheContact) {
        const data = contactsQuery.result.filter(function (el) {
          return el?.id !== contact.id;
        });
        client.writeQuery({
          query: ContactsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const removeProductFromCache = (product: IProduct): void => {
  try {
    const productsQuery = client.cache.readQuery({
      query: ProductsDocument
    }) as IProductsQuery;
    if (productsQuery.result) {
      const cacheProduct = productsQuery.result.find((p) => p?.id === product.id);
      if (cacheProduct) {
        const data = productsQuery.result.filter(function (el) {
          return el?.id !== product.id;
        });
        client.writeQuery({
          query: ProductsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const removeTemplateFromCache = (template: ITemplate): void => {
  try {
    const templatesQuery = client.cache.readQuery({
      query: TemplatesDocument
    }) as ITemplatesQuery;
    if (templatesQuery.result) {
      const cacheTemplate = templatesQuery.result.find((t) => t?.id === template.id);
      if (cacheTemplate) {
        const data = templatesQuery.result.filter(function (el) {
          return el?.id !== template.id;
        });
        client.writeQuery({
          query: TemplatesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const addTemplateInCache = (template: ITemplate): void => {
  try {
    const templatesQuery = client.cache.readQuery({
      query: TemplatesDocument
    }) as ITemplatesQuery;
    if (templatesQuery.result) {
      const cacheTemplate = templatesQuery.result.find((t) => t?.id === template.id);
      if (!cacheTemplate) {
        const newData = [template, ...templatesQuery.result];
        client.writeQuery({
          query: TemplatesDocument,
          data: { result: newData }
        });
      }
    }
  } catch (e) {}
};

export const updateTemplateInCache = (template: ITemplate): void => {
  try {
    const templatesQuery = client.cache.readQuery({
      query: TemplatesDocument
    }) as ITemplatesQuery;
    if (templatesQuery.result) {
      const data = templatesQuery.result.map((t) => (t?.id === template.id ? template : t));
      client.writeQuery({
        query: TemplatesDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeMembershipFromCache = (membership: IMembership): void => {
  try {
    const membershipsQuery = client.cache.readQuery({
      query: MembershipsDocument
    }) as IMembershipsQuery;
    if (membershipsQuery.result) {
      const cacheMembership = membershipsQuery.result.find((m) => m?.id === membership.id);
      if (cacheMembership) {
        const data = membershipsQuery.result.filter(function (el) {
          return el?.id !== membership.id;
        });
        client.writeQuery({
          query: MembershipsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const addContactToCache = (contact: IContact): void => {
  try {
    const contactsQuery = client.cache.readQuery({
      query: ContactsDocument
    }) as IContactsQuery;

    // Check if contactsQuery and contactsQuery.result exist before proceeding
    if (contactsQuery && contactsQuery.result) {
      const cacheContact = contactsQuery.result.find((c) => c?.id === contact.id);
      if (!cacheContact) {
        const data = [contact, ...contactsQuery.result];
        client.writeQuery({
          query: ContactsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateContactInCache = (contact: IContact): void => {
  try {
    const contactsQuery = client.cache.readQuery({
      query: ContactsDocument
    }) as IContactsQuery;

    // Check if contactsQuery and contactsQuery.result exist before proceeding
    if (contactsQuery && contactsQuery.result) {
      const data = contactsQuery.result.map((c) => (c?.id === contact.id ? contact : c));
      client.writeQuery({
        query: ContactsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const addProductToCache = (product: IProduct): void => {
  try {
    const productQuery = client.cache.readQuery({
      query: ProductsDocument
    }) as IProductsQuery;
    if (productQuery.result) {
      const cacheProduct = productQuery.result.find((p) => p?.id === product.id);
      if (!cacheProduct) {
        const data = [product, ...productQuery.result];
        client.writeQuery({
          query: ProductsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateProductInCache = (product: IProduct): void => {
  try {
    const productQuery = client.cache.readQuery({
      query: ProductsDocument
    }) as IProductsQuery;
    if (productQuery.result) {
      const data = productQuery.result.map((p) => (p?.id === product.id ? product : p));
      client.writeQuery({
        query: ProductsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const sameMembershipNameExist = (name: string, id?: string): boolean => {
  let result = false;
  try {
    const membershipsQuery = client.cache.readQuery({
      query: MembershipsDocument
    }) as IMembershipsQuery;
    if (membershipsQuery.result) {
      if (id) {
        const memberships = membershipsQuery.result.filter(
          (m) => m?.name.trim().toLocaleLowerCase() === name.trim().toLocaleLowerCase()
        );
        const sameMembershipNames = memberships.filter((m) => m?.id !== id);
        return sameMembershipNames.length > 0;
      } else {
        const membership = membershipsQuery.result.find(
          (m) => m?.name.trim().toLocaleLowerCase() === name.trim().toLocaleLowerCase()
        );
        result = membership ? true : false;
        return result;
      }
    }
  } catch (e) {
    return result;
  }

  return result;
};

export const sameSchedulerNameExist = (name: string, id?: string | null): boolean => {
  let result = false;
  try {
    const schedulersQuery = client.cache.readQuery({
      query: GetAllScheduledDocument
    }) as IGetAllScheduledQuery;
    if (schedulersQuery.result) {
      if (id) {
        const schedulers = schedulersQuery.result.filter(
          (s) => s?.name.trim().toLowerCase() === name.trim().toLowerCase()
        );
        const sameSchedulersNames = schedulers.filter((s) => s?.id !== id);
        return sameSchedulersNames.length > 0;
      } else {
        const scheduler = schedulersQuery.result.find(
          (s) => s?.name.trim().toLowerCase() === name.trim().toLowerCase()
        );
        result = scheduler ? true : false;
        return result;
      }
    }
  } catch (e) {
    return result;
  }

  return result;
};

export const addMembershipToCache = (membership: IMembership): void => {
  try {
    const membershipQuery = client.cache.readQuery({
      query: MembershipsDocument
    }) as IMembershipsQuery;
    if (membershipQuery.result) {
      const cacheMembership = membershipQuery.result.find((m) => m?.id === membership.id);
      if (!cacheMembership) {
        const data = [membership, ...membershipQuery.result];
        client.writeQuery({
          query: MembershipsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateMembershipInCache = (membership: IMembership): void => {
  try {
    const membershipQuery = client.cache.readQuery({
      query: MembershipsDocument
    }) as IMembershipsQuery;
    if (membershipQuery.result) {
      const data = membershipQuery.result.map((m) => (m?.id === membership.id ? membership : m));
      client.writeQuery({
        query: MembershipsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const addInvoiceInCache = (invoice: IInvoice): void => {
  try {
    const invoiceQuery = client.cache.readQuery({
      query: InvoicesDocument
    }) as IInvoicesQuery;
    if (invoiceQuery.result) {
      const cacheInvoice = invoiceQuery.result.find((i) => i?.id === invoice.id);
      if (!cacheInvoice) {
        const data = [invoice, ...invoiceQuery.result];
        client.writeQuery({
          query: InvoicesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateInvoiceInCache = (invoice: IInvoice): void => {
  try {
    const invoiceQuery = client.cache.readQuery({
      query: InvoicesDocument
    }) as IInvoicesQuery;
    if (invoiceQuery.result) {
      const data = invoiceQuery.result.map((i) => (i?.id === invoice.id ? invoice : i));
      client.writeQuery({
        query: InvoicesDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeInvoiceFromCache = (invoice: IInvoice): void => {
  try {
    const invoiceQuery = client.cache.readQuery({
      query: InvoicesDocument
    }) as IInvoicesQuery;
    if (invoiceQuery.result) {
      const cacheInvoice = invoiceQuery.result.find((i) => i?.id === invoice.id);
      if (cacheInvoice) {
        const data = invoiceQuery.result.filter((el) => {
          return el?.id !== invoice.id;
        });
        client.writeQuery({
          query: InvoicesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const parseDate = (input: string | null | undefined): Date | null => {
  if (input !== null && input !== undefined) {
    return new Date(Number(input as string));
  }
  return null;
};

export const updateUserInCache = (user: IUser): void => {
  try {
    const usersQuery = client.cache.readQuery({
      query: GetUsersDocument
    }) as IGetUsersQuery;
    if (usersQuery.result) {
      const data = usersQuery.result.map((u) => (u?.id === user.id ? user : u));
      client.writeQuery({
        query: GetUsersDocument,
        data: { result: data }
      });
    }
  } catch (e) {
  } finally {
    updateUserGroupsInCache(user);
  }
};

export const updateUserGroupsInCache = (user: IUser): void => {
  try {
    const groupsQuery = client.cache.readQuery({
      query: GetRolesDocument
    }) as IGetRolesQuery;
    if (groupsQuery.result) {
      const data = groupsQuery.result.map((gr) => {
        if (user.roles.includes(gr?.name as string)) {
          if ((gr as IRole).users.filter((u) => u?.id === user.id).length > 0) {
            return gr;
          } else {
            return { ...gr, users: [user, ...(gr as IRole).users] };
          }
        } else {
          if ((gr as IRole).users.filter((u) => u?.id === user.id).length > 0) {
            return { ...gr, users: (gr as IRole).users.filter((us) => us?.id !== user.id) };
          } else {
            return gr;
          }
        }
      });
      client.writeQuery({
        query: GetRolesDocument,
        data: { result: data }
      });
    }
  } catch (error) {}
};

export const removeUserFromAllGroupsInCache = (userId: string): void => {
  try {
    const groupsQuery = client.cache.readQuery({
      query: GetRolesDocument
    }) as IGetRolesQuery;
    if (groupsQuery.result) {
      const data = groupsQuery.result.map((gr) => {
        return { ...gr, users: (gr as IRole).users.filter((us) => us?.id !== userId) };
      });
      client.writeQuery({
        query: GetRolesDocument,
        data: { result: data }
      });
    }
  } catch (error) {}
};

export const addUsersToGroupInCache = (roleId: string, users: IUser[]): void => {
  try {
    const groupsQuery = client.cache.readQuery({
      query: GetRolesDocument
    }) as IGetRolesQuery;
    if (groupsQuery.result) {
      const data = groupsQuery.result.map((gr) =>
        gr?.id === roleId ? { ...gr, users: [...users, ...gr.users] } : gr
      );
      client.writeQuery({
        query: GetRolesDocument,
        data: { result: data }
      });
    }
  } catch (error) {}
};

export const addValuesToCache = (valueListName: string, newValues: IAddValueResult[]): void => {
  switch (valueListName) {
    case ValueLists.CompanyType:
      addCompanyTypesToCache(newValues);
      break;
    case ValueLists.MarketActivity:
      addMarketActivitiesToCache(newValues);
      break;
    case ValueLists.MembershipType:
      addMembershipTypesToCache(newValues);
      break;
    case ValueLists.ProductCode:
      addProductCodesToCache(newValues);
      break;
    case ValueLists.TitleInternal:
      addTitlesInternalToCache(newValues);
      break;
    default:
      break;
  }
};

export const addInterestsToCache = (id: string, newInterests: IAddInterestResult[]): void => {
  if (newInterests.length > 0) {
    try {
      const interestsQuery = client.cache.readQuery({
        query: GetInterestGroupsDocument
      }) as IGetInterestGroupsQuery;
      if (interestsQuery.result) {
        const interestsToAdd = newInterests as unknown as IInterest[];
        const result = interestsQuery.result.map((ig) =>
          ig?.id === id
            ? {
                ...ig,
                interests: [...interestsToAdd, ...ig.interests]
              }
            : ig
        );
        client.writeQuery({
          query: GetInterestGroupsDocument,
          data: { result }
        });
      }
    } catch {}
  }
};

export const remoteInterestInCache = (interest: IInterest): void => {
  try {
    const interestGroups = client.cache.readQuery({
      query: GetInterestGroupsDocument
    }) as IGetInterestGroupsQuery;
    if (interestGroups.result) {
      const data = interestGroups.result.map((gr) => {
        if (gr?.id === interest.interest_group.id) {
          return { ...gr, interests: gr.interests.filter((i) => i?.id !== interest.id) };
        } else {
          return gr;
        }
      });
      client.writeQuery({
        query: GetInterestGroupsDocument,
        data: { result: data }
      });
    }
  } catch (error) {}
};

export const removeRecipientListFromCache = (recipientListId: string): void => {
  try {
    const recipientListsQuery = client.cache.readQuery({
      query: RecipientListsDocument
    }) as IRecipientListsQuery;
    if (recipientListsQuery.result) {
      const cacheRecipientList = recipientListsQuery.result.find((r) => r?.id === recipientListId);
      if (cacheRecipientList) {
        const data = recipientListsQuery.result.filter((r) => r?.id !== recipientListId);
        client.writeQuery({
          query: RecipientListsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const addSchedulerToCache = (scheduler: IScheduler): void => {
  try {
    const schedulerQuery = client.cache.readQuery({
      query: GetAllScheduledDocument
    }) as IGetAllScheduledQuery;
    if (schedulerQuery.result) {
      const cacheScheduler = schedulerQuery.result.find((s) => s?.id === scheduler.id);
      if (!cacheScheduler) {
        const data = [scheduler, ...schedulerQuery.result];
        client.writeQuery({
          query: GetAllScheduledDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const addEventToCache = (event: ICalendarEvent): void => {
  try {
    const eventQuery = client.cache.readQuery({
      query: EventsDocument
    }) as IEventsQuery;
    if (eventQuery.result) {
      const cacheEvent = eventQuery.result.find((s) => s?.id === event.id);
      if (!cacheEvent) {
        const data = [event, ...eventQuery.result];
        client.writeQuery({
          query: EventsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateEventInCache = (event: ICalendarEvent): void => {
  try {
    const eventquery = client.cache.readQuery({
      query: EventsDocument
    }) as IEventsQuery;
    if (eventquery.result) {
      const data = eventquery.result.map((e) => (e?.id === event.id ? event : e));
      client.writeQuery({
        query: EventsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeEventFromCache = (eventId: string): void => {
  try {
    const eventQuery = client.cache.readQuery({
      query: EventsDocument
    }) as IEventsQuery;
    if (eventQuery.result) {
      const cacheEvent = eventQuery.result.find((e) => e?.id === eventId);
      if (cacheEvent) {
        const data = eventQuery.result.filter((e) => e?.id !== eventId);
        client.writeQuery({
          query: EventsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateSchedulerInCache = (scheduler: IScheduler): void => {
  try {
    const schedulerQuery = client.cache.readQuery({
      query: GetAllScheduledDocument
    }) as IGetAllScheduledQuery;
    if (schedulerQuery.result) {
      const data = schedulerQuery.result.map((s) => (s?.id === scheduler.id ? scheduler : s));
      client.writeQuery({
        query: GetAllScheduledDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeSchedulerFromCache = (schedulerId: string): void => {
  try {
    const schedulerQuery = client.cache.readQuery({
      query: GetAllScheduledDocument
    }) as IGetAllScheduledQuery;
    if (schedulerQuery.result) {
      const cacheScheduler = schedulerQuery.result.find((s) => s?.id === schedulerId);
      if (cacheScheduler) {
        const data = schedulerQuery.result.filter((s) => s?.id !== schedulerId);
        client.writeQuery({
          query: GetAllScheduledDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const addRecipientListInCache = (recipientList: IRecipientList): void => {
  try {
    const recipientListQuery = client.cache.readQuery({
      query: RecipientListsDocument
    }) as IRecipientListsQuery;
    if (recipientListQuery.result) {
      const cacheRecipientList = recipientListQuery.result.find((r) => r?.id === recipientList.id);
      if (!cacheRecipientList) {
        const data = [recipientList, ...recipientListQuery.result];
        client.writeQuery({
          query: RecipientListsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateRecipientListInCache = (recipientList: IRecipientList): void => {
  try {
    const recipientListQuery = client.cache.readQuery({
      query: RecipientListsDocument
    }) as IRecipientListsQuery;
    if (recipientListQuery.result) {
      const data = recipientListQuery.result.map((r) =>
        r?.id === recipientList.id ? recipientList : r
      );
      client.writeQuery({
        query: RecipientListsDocument,
        data: { result: data }
      });
    }
  } catch (error) {}
};

const addCompanyTypesToCache = (newValues: IAddValueResult[]): void => {
  if (newValues.length > 0) {
    try {
      const companyTypesQuery = client.cache.readQuery({
        query: CompanyTypesDocument
      }) as ICompanyTypesQuery;
      if (companyTypesQuery.result) {
        const valuesToAdd = newValues.map((nv) => ({
          ...nv,
          __typename: 'CompanyType'
        })) as ICompanyType[];
        client.writeQuery({
          query: CompanyTypesDocument,
          data: { result: [...valuesToAdd, ...companyTypesQuery.result] }
        });
      }
    } catch (error) {}
  }
};

const addMarketActivitiesToCache = (newValues: IAddValueResult[]): void => {
  if (newValues.length > 0) {
    try {
      const marketActivitiesQuery = client.cache.readQuery({
        query: MarketActivitiesDocument
      }) as IMarketActivitiesQuery;
      if (marketActivitiesQuery.result) {
        const valuesToAdd = newValues.map((nv) => ({
          ...nv,
          __typename: 'MarketActivity'
        })) as IMarketActivity[];
        client.writeQuery({
          query: CompanyTypesDocument,
          data: { result: [...valuesToAdd, ...marketActivitiesQuery.result] }
        });
      }
    } catch (error) {}
  }
};

const addMembershipTypesToCache = (newValues: IAddValueResult[]): void => {
  if (newValues.length > 0) {
    try {
      const membershipTypesQuery = client.cache.readQuery({
        query: MembershipTypesDocument
      }) as IMembershipTypesQuery;
      if (membershipTypesQuery.result) {
        const valuesToAdd = newValues.map((nv) => ({
          ...nv,
          __typename: 'MembershipType'
        })) as IMembershipType[];
        client.writeQuery({
          query: MembershipTypesDocument,
          data: { result: [...valuesToAdd, ...membershipTypesQuery.result] }
        });
      }
    } catch (error) {}
  }
};

const addProductCodesToCache = (newValues: IAddValueResult[]): void => {
  if (newValues.length > 0) {
    try {
      const productCodesQuery = client.cache.readQuery({
        query: ProductCodesDocument
      }) as IProductCodesQuery;
      if (productCodesQuery.result) {
        const valuesToAdd = newValues.map((nv) => ({
          ...nv,
          __typename: 'ProductCode'
        })) as IProductCode[];
        client.writeQuery({
          query: ProductCodesDocument,
          data: { result: [...valuesToAdd, ...productCodesQuery.result] }
        });
      }
    } catch (error) {}
  }
};

const addTitlesInternalToCache = (newValues: IAddValueResult[]): void => {
  if (newValues.length > 0) {
    try {
      const titlesInternalQuery = client.cache.readQuery({
        query: TitlesInternalDocument
      }) as ITitlesInternalQuery;
      if (titlesInternalQuery.result) {
        const valuesToAdd = newValues.map((nv) => ({
          ...nv,
          __typename: 'TitleInternal'
        })) as ITitleInternal[];
        client.writeQuery({
          query: TitlesInternalDocument,
          data: { result: [...valuesToAdd, ...titlesInternalQuery.result] }
        });
      }
    } catch (error) {}
  }
};

export const removeValueFromCache = (
  valueListName: string,
  valueToRemove: ICompanyType | IMarketActivity | IMembershipType | IProductCode | ITitleInternal
): void => {
  const { id } = valueToRemove;
  switch (valueListName) {
    case ValueLists.CompanyType:
      removeCompanyTypeFromCache(id);
      break;
    case ValueLists.MarketActivity:
      removeMarketActivityFromCache(id);
      break;
    case ValueLists.MembershipType:
      removeMembershipTypeFromCache(id);
      break;
    case ValueLists.ProductCode:
      removeProductCodeFromCache(id);
      break;
    case ValueLists.TitleInternal:
      removeTitleInternalFromCache(id);
      break;
    default:
      break;
  }
};

const removeCompanyTypeFromCache = (id: string): void => {
  try {
    const companyTypesQuery = client.cache.readQuery({
      query: CompanyTypesDocument
    }) as ICompanyTypesQuery;
    if (companyTypesQuery.result) {
      client.writeQuery({
        query: CompanyTypesDocument,
        data: { result: companyTypesQuery.result.filter((ct) => ct?.id !== id) }
      });
    }
  } catch (error) {}
};

const removeMarketActivityFromCache = (id: string): void => {
  try {
    const marketActivitiesQuery = client.cache.readQuery({
      query: MarketActivitiesDocument
    }) as IMarketActivitiesQuery;
    if (marketActivitiesQuery.result) {
      client.writeQuery({
        query: MarketActivitiesDocument,
        data: { result: marketActivitiesQuery.result.filter((ma) => ma?.id !== id) }
      });
    }
  } catch (error) {}
};

const removeMembershipTypeFromCache = (id: string): void => {
  try {
    const membershipTypesQuery = client.cache.readQuery({
      query: MembershipTypesDocument
    }) as IMembershipTypesQuery;
    if (membershipTypesQuery.result) {
      client.writeQuery({
        query: MembershipTypesDocument,
        data: { result: membershipTypesQuery.result.filter((m) => m?.id !== id) }
      });
    }
  } catch (error) {}
};

const removeProductCodeFromCache = (id: string): void => {
  try {
    const productCodesQuery = client.cache.readQuery({
      query: ProductCodesDocument
    }) as IProductCodesQuery;
    if (productCodesQuery.result) {
      client.writeQuery({
        query: ProductCodesDocument,
        data: { result: productCodesQuery.result.filter((pc) => pc?.id !== id) }
      });
    }
  } catch (error) {}
};

const removeTitleInternalFromCache = (id: string): void => {
  try {
    const titlesInternalQuery = client.cache.readQuery({
      query: TitlesInternalDocument
    }) as ITitlesInternalQuery;
    if (titlesInternalQuery.result) {
      client.writeQuery({
        query: TitlesInternalDocument,
        data: { result: titlesInternalQuery.result.filter((ti) => ti?.id !== id) }
      });
    }
  } catch (error) {}
};

export const addStockInCache = (stock: IStock): void => {
  try {
    const stocksQuery = client.cache.readQuery({
      query: StocksDocument
    }) as IStocksQuery;
    if (stocksQuery.result) {
      const cacheStock = stocksQuery.result.find((s) => s?.id === stock.id);
      if (!cacheStock) {
        const data = [stock, ...stocksQuery.result];
        client.writeQuery({
          query: StocksDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
    console.log('addStockInCache error: ', e);
  }
};

export const addFtseFileInCache = (ftse: IFtseFile): void => {
  try {
    const ftseQuery = client.cache.readQuery({
      query: GetFtseFilesDocument
    }) as IGetFtseFilesQuery;
    if (ftseQuery.result) {
      const cacheFtse = ftseQuery.result.find((fts) => fts?.id === ftse.id);
      if (!cacheFtse) {
        const data = [ftse, ...ftseQuery.result];
        client.writeQuery({
          query: GetFtseFilesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
    console.log('createIndexCache error:', e);
  }
};

export const updateFtseFileInCache = (ftse: IFtseFile): void => {
  try {
    const ftseQuery = client.cache.readQuery({
      query: GetFtseFilesDocument
    }) as IGetFtseFilesQuery;
    if (ftseQuery.result) {
      const data = ftseQuery.result.map((fts) => (fts?.id === ftse.id ? ftse : fts));
      client.writeQuery({
        query: GetFtseFilesDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeFtseFileFromCache = (ftseFile: IFtseFile): void => {
  try {
    const ftseFilesQuery = client.cache.readQuery({
      query: GetFtseFilesDocument
    }) as IGetFtseFilesQuery;
    if (ftseFilesQuery.result) {
      const cacheFtseFileIndex = ftseFilesQuery.result.findIndex((c) => c?.id === ftseFile.id);
      if (cacheFtseFileIndex > -1) {
        const data = ftseFilesQuery.result.filter(function (el) {
          return el?.id !== ftseFile.id;
        });
        client.writeQuery({
          query: GetFtseFilesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
    console.log('deteledFtseFileCache error:', e);
  }
};

export const addIndexInCache = (index: IIndex): void => {
  try {
    const indexQuery = client.cache.readQuery({
      query: IndicesDocument
    }) as IIndicesQuery;
    if (indexQuery.result) {
      const cacheIndex = indexQuery.result.find((i) => i?.id === index.id);
      if (!cacheIndex) {
        const data = [index, ...indexQuery.result];
        client.writeQuery({
          query: IndicesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
    console.log('createIndexCache error:', e);
  }
};

export const removeIndexFromCache = (index: IIndex): void => {
  try {
    const indexQuery = client.cache.readQuery({
      query: IndicesDocument
    }) as IIndicesQuery;
    if (indexQuery.result) {
      client.writeQuery({
        query: IndicesDocument,
        data: { result: indexQuery.result.filter((i) => i?.id !== index.id) }
      });
    }
  } catch (e) {
    console.log('createIndexCache error:', e);
  }
};

export const updateIndexInCache = (index: IIndex): void => {
  try {
    const indexQuery = client.cache.readQuery({
      query: IndicesDocument
    }) as IIndicesQuery;
    if (indexQuery.result) {
      const data = indexQuery.result.map((i) => (i?.id === index.id ? index : i));
      client.writeQuery({
        query: IndicesDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const updateStockInCache = (stock: IStock): void => {
  try {
    const stocksQuery = client.cache.readQuery({
      query: StocksDocument
    }) as IStocksQuery;
    if (stocksQuery.result) {
      const data = stocksQuery.result.map((s) => (s?.id === stock.id ? stock : s));
      client.writeQuery({
        query: StocksDocument,
        data: { result: data }
      });
    }
  } catch (e) {
    console.log('updateStockInCache error: ', e);
  }
};

export const stockCodeExists = (code: string, id?: number): boolean => {
  try {
    const stocksQuery = client.cache.readQuery({
      query: StocksDocument
    }) as IStocksQuery;
    if (stocksQuery.result) {
      const stocks = stocksQuery.result.filter(
        (s) => s?.code?.toLowerCase() === code.trim().toLowerCase()
      );
      if (stocks.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedStocks = stocks.filter((s) => parseInt(s?.id as string) !== id);
          return refinedStocks.length > 0;
        }
        return true;
      }
    }
  } catch (e) {
    return false;
  }

  return false;
};

export const removeIndexSerieFromCache = (indexSerie: IIndexSerie): void => {
  try {
    const indexSerieQuery = client.cache.readQuery({
      query: IndexSeriesDocument
    }) as IIndexSeriesQuery;
    if (indexSerieQuery.result) {
      const updatedData = indexSerieQuery.result.filter((i) => i?.id !== indexSerie.id);
      client.writeQuery({
        query: IndexSeriesDocument,
        data: { result: updatedData }
      });
    }
  } catch (e) {
    console.log('deleteIndexSerieCache error:', e);
  }
};

export const addIndexSerieInCache = (indexSerie: IIndexSerie): void => {
  try {
    const indexSerieQuery = client.cache.readQuery({
      query: IndexSeriesDocument
    }) as IIndexSeriesQuery;
    if (indexSerieQuery.result) {
      const cacheIndexSerie = indexSerieQuery.result.find((is) => is?.id === indexSerie.id);
      if (!cacheIndexSerie) {
        const data = [indexSerie, ...indexSerieQuery.result];
        client.writeQuery({
          query: IndexSeriesDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {
    console.log('createIndexSerieCache error:', e);
  }
};

export const updateIndexSerieInCache = (indexSerie: IIndexSerie): void => {
  try {
    const indexSerieQuery = client.cache.readQuery({
      query: IndexSeriesDocument
    }) as IIndexSeriesQuery;
    if (indexSerieQuery.result) {
      const data = indexSerieQuery.result.map((is) => (is?.id === indexSerie.id ? indexSerie : is));
      client.writeQuery({
        query: IndexSeriesDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const addEtfInCache = (etf: IEtf): void => {
  try {
    const etfQuery = client.cache.readQuery({
      query: GetEtfsDocument
    }) as IGetEtfsQuery;
    if (etfQuery.result) {
      const cacheEtfSerie = etfQuery.result.find((e) => e?.id === etf.id);
      if (!cacheEtfSerie) {
        const data = [etf, ...etfQuery.result];
        client.writeQuery({
          query: GetEtfsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const updateEtfInCache = (etf: IEtf): void => {
  try {
    const etfQuery = client.cache.readQuery({
      query: GetEtfsDocument
    }) as IGetEtfsQuery;
    if (etfQuery.result) {
      const data = etfQuery.result.map((e) => (e?.id === etf.id ? etf : e));
      client.writeQuery({
        query: GetEtfsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const removeEtfFromChache = (etf: IEtf): void => {
  try {
    const etfsQuery = client.cache.readQuery({
      query: GetEtfsDocument
    }) as IGetEtfsQuery;
    if (etfsQuery.result) {
      client.writeQuery({
        query: GetEtfsDocument,
        data: { result: etfsQuery.result.filter((e) => e?.id !== etf.id) }
      });
    }
  } catch (e) {}
};

export const updateFtseConfigurationInCache = (ftseConfiguration: IFtseConfiguration): void => {
  try {
    const ftseConfigurationsQuery = client.cache.readQuery({
      query: GetFtseConfigurationsDocument
    }) as IGetFtseConfigurationsQuery;
    if (ftseConfigurationsQuery.result) {
      const data = ftseConfigurationsQuery.result.map((f) =>
        f?.id === ftseConfiguration.id ? ftseConfiguration : f
      );
      client.writeQuery({
        query: GetFtseConfigurationsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const sameSiteSectionNameExists = (name: string, id?: string): boolean => {
  try {
    const sectionsQuery = client.cache.readQuery({
      query: GetSiteSectionsDocument
    }) as IGetSiteSectionsQuery;
    if (sectionsQuery.result) {
      const sections = sectionsQuery.result.filter(
        (s) => s?.name.toUpperCase() === name.toUpperCase()
      );
      if (sections.length === 0) {
        return false;
      } else {
        if (id) {
          const refinedSections = sections.filter((s) => s?.id !== id);
          return refinedSections.length > 0;
        }
        return true;
      }
    }
  } catch (error) {
    return false;
  }
  return false;
};

export const removeDocumentFromCache = (document: IDocument): void => {
  try {
    const docsQuery = client.cache.readQuery({
      query: DocumentsDocument
    }) as IDocumentsQuery;
    if (docsQuery.result) {
      client.writeQuery({
        query: DocumentsDocument,
        data: { result: docsQuery.result.filter((d) => d?.id !== document.id) }
      });
    }
  } catch (e) {}
};

export const updateDocumentInCache = (document: IDocument): void => {
  try {
    const docsQuery = client.cache.readQuery({
      query: DocumentsDocument
    }) as IDocumentsQuery;
    if (docsQuery.result) {
      client.writeQuery({
        query: DocumentsDocument,
        data: { result: docsQuery.result.map((d) => (d?.id === document.id ? document : d)) }
      });
    }
  } catch (e) {}
};

export const addDocumentInCache = (document: IDocument): void => {
  try {
    const docsQuery = client.cache.readQuery({
      query: DocumentsDocument
    }) as IDocumentsQuery;
    if (docsQuery.result) {
      const cacheDoc = docsQuery.result.find((d) => d?.id === document.id);
      if (!cacheDoc) {
        const data = [document, ...docsQuery.result];
        client.writeQuery({
          query: DocumentsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const addSiteSectionInCache = (siteSection: ISiteSection): void => {
  try {
    const sectionsQuery = client.cache.readQuery({
      query: GetSiteSectionsDocument
    }) as IGetSiteSectionsQuery;
    if (sectionsQuery.result) {
      const cacheSection = sectionsQuery.result.find((s) => s?.id === siteSection.id);
      if (!cacheSection) {
        const data = [siteSection, ...sectionsQuery.result];
        client.writeQuery({
          query: GetSiteSectionsDocument,
          data: { result: data }
        });
      }
    }
  } catch (e) {}
};

export const removeSiteSectionFromCache = (siteSection: ISiteSection): void => {
  try {
    const sectionsQuery = client.cache.readQuery({
      query: GetSiteSectionsDocument
    }) as IGetSiteSectionsQuery;
    if (sectionsQuery.result) {
      client.writeQuery({
        query: GetSiteSectionsDocument,
        data: { result: sectionsQuery.result.filter((s) => s?.id !== siteSection.id) }
      });
    }
  } catch (e) {}
};

export const updateSiteSectionInCache = (siteSection: ISiteSection): void => {
  try {
    const sectionsQuery = client.cache.readQuery({
      query: GetSiteSectionsDocument
    }) as IGetSiteSectionsQuery;
    if (sectionsQuery.result) {
      const data = sectionsQuery.result.map((s) => (s?.id === siteSection.id ? siteSection : s));
      client.writeQuery({
        query: GetSiteSectionsDocument,
        data: { result: data }
      });
    }
  } catch (e) {}
};

export const getStringInput = (input: string | null | undefined): string | null | undefined => {
  if (input && input.length > 0) {
    return input;
  }
  return undefined;
};

export const getNumberInput = (input: string): number | undefined => {
  if (input.length > 0) {
    return Number(input);
  }
  return undefined;
};

export const getNullableNumberInput = (input: string): number | null => {
  if (input.length > 0) {
    return Number(input);
  }
  return null;
};

export const getNullableDateString = (input: Date | null) => {
  if (input) {
    return input.toString();
  }
  return undefined;
};

export const getObjectInputId = (input: string | undefined): number | undefined => {
  return input ? Number(input) : undefined;
};
